import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { CrowdFlowROI } from '../../model/crowd-flow-roi';

export interface CrowdFlowROIState extends EntityState<CrowdFlowROI> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'CrowdFlowROI' })
export class CrowdFlowROIStore extends EntityStore<CrowdFlowROIState> {

  constructor() {
    super();
  }

}
